<template>
  <div>
    <v-data-table :headers="headers" :items="dataList" class="elevation-1 mt-2" :mobile-breakpoint="0" :loading="loading">
      <template v-slot:[`item.oneDay`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.oneDay"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.fiveDays`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.fiveDays"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.tenDays`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.tenDays"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.fifteenDays`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.fifteenDays"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.twentyDays`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.twentyDays"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.twentyFiveDays`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.twentyFiveDays"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.thirtyDays`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.thirtyDays"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.minQtyChangePriceMinus`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.minQtyChangePriceMinus"></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.minQtyChangePricePlus`]="{ item }">
        <div class="d-flex justify-center align-center mt-4">
          <v-text-field :rules="[requiredValidatorNumber('amount')]" solo dense name="input-7-4" type="number" v-model="item.minQtyChangePricePlus"></v-text-field>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { requiredValidatorNumber } from "../../core/methods/validations";
export default {
  components: {},
  data() {
    return {
      requiredValidatorNumber,
      snack: false,
      loading: false,
      dataList: [],
      headers: [
        { text: "Category", value: "category", width: "175" },
        { text: "1 Day", value: "oneDay" },
        { text: "6 Days", value: "fiveDays" },
        { text: "12 Days", value: "tenDays" },
        { text: "20 Days", value: "fifteenDays" },
        { text: "26 Days", value: "twentyDays" },
        { text: "Price Reduce After Plan Quantity", value: "minQtyChangePriceMinus", width: "120" },
        { text: "Price Increase After Plan Quantity", value: "minQtyChangePricePlus", width: "120" },
      ],
    };
  },
  props: {
    allCategories: {
      required: true,
    },
    packagesInfo: {
      type: Array,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    allCategories: {
      handler() {
        this.initPage();
      },
      deep: true,
    },
    dataList: {
      handler(newVal) {
        this.$emit("updateCustomization", newVal);
      },
      deep: true,
    },
    packagesInfo: {
      handler() {
        this.initPage();
      },
      deep: true,
    },
  },

  apollo: {},
  created() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.dataList = [];
      this.allCategories
        .filter(x => x.hasMeal)
        .forEach(item => {
          let data = {
            category: item.nameEn,
            categoryId: item._id,
            oneDay: "",
            fiveDays: "",
            tenDays: "",
            fifteenDays: "",
            twentyDays: "",
            twentyFiveDays: "",
            thirtyDays: "",
            minQtyChangePriceMinus: "",
            minQtyChangePricePlus: "",
          };
          this.dataList.push(data);
        });

      if (this.isEdit && this.packagesInfo && this.packagesInfo.planCustomization) {
        console.log("this.packagesInfo", this.packagesInfo);
        console.log("this.dataList", this.dataList);

        this.dataList.forEach(item => {
          let planCustomization = this.packagesInfo.planCustomization.filter(x => x.category._id === item.categoryId);
          if (planCustomization) {
            let oneItemValue = planCustomization.find(x => x.noOfDays == 1);
            let fiveItemValue = planCustomization.find(x => x.noOfDays == 6);
            let tenItemValue = planCustomization.find(x => x.noOfDays == 12);
            let fifteenItemValue = planCustomization.find(x => x.noOfDays == 20);
            let twentyItemValue = planCustomization.find(x => x.noOfDays == 26);

            if (oneItemValue) {
              item.oneDay = oneItemValue.pricePerDay || "";
            }
            if (fiveItemValue) {
              item.fiveDays = fiveItemValue.pricePerDay || "";
            }
            if (tenItemValue) {
              item.tenDays = tenItemValue.pricePerDay || "";
            }
            if (fifteenItemValue) {
              item.fifteenDays = fifteenItemValue.pricePerDay || "";
            }
            if (twentyItemValue) {
              item.twentyDays = twentyItemValue.pricePerDay || "";
            }

            item.minQtyChangePriceMinus = planCustomization[0].minQtyChangePriceMinus || 0;
            item.minQtyChangePricePlus = planCustomization[0].minQtyChangePricePlus || 0;
          }
        });
      }
    },
  },

  mounted() {},
};
</script>
